import { Config } from './config.model';

/**
 * Global configuration manager for use in decorators and other contexts
 * where Angular DI is not available.
 *
 * For regular Angular components/services, use ConfigService instead
 * which provides the same functionality through dependency injection.
 */
export class GlobalConfigManager {
  private static instance: GlobalConfigManager | null = null;
  private readonly config: Config;

  private constructor(config: Config) {
    this.config = config;
  }

  static tryCreateInstance(config: Config): GlobalConfigManager {
    if (this.instance) {
      throw new Error('GlobalConfigManager already initialized.');
    }
    this.instance = new GlobalConfigManager(config);

    return this.instance;
  }

  static tryGetInstance(): GlobalConfigManager {
    if (!this.instance) {
      throw new Error('GlobalConfigManager not initialized. Call createInstance() first.');
    }

    return this.instance;
  }

  getConfig(): Config {
    return this.config;
  }
}
